import React from 'react'

export default () => {
  return (
    <div style={{borderBottom:"1px solid #e0e0e0",marginTop:10,marginBottom:10,width:"100%"}}> </div>
  )
}
